const AVATAR_COLORS = [
  "#2563EB",
  "#10B981",
  "#F59E0B",
  "#6366F1",
  "#EC4899",
  "#14B8A6",
];

// Deterministic avatar background from a person's name — shared by every avatar in the app
// (Members' MemberCard, PackageManagement's row, PackageDetailsModal's header) so the same
// member always gets the same color no matter where their avatar is shown. Lives here (not in
// Members/index.js, where it originally was) so components outside Members can import it
// without creating a circular dependency back on Members/index.js.
export const colorForName = (name) => {
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length];
};
